var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2059 18.9851C16.949 19.7201 18.1467 19.7174 18.8879 18.9775L24.586 13.2796C25.3288 12.5367 25.3288 11.3323 24.586 10.5895C23.8432 9.84667 22.6388 9.84667 21.8959 10.5895L19.4451 13.0402V3.62145C19.4451 2.57084 18.5935 1.71927 17.543 1.71927C16.4924 1.71927 15.6408 2.57084 15.6408 3.62145V13.0403L13.19 10.5896C12.4471 9.84667 11.2427 9.84667 10.4999 10.5896C9.75711 11.3325 9.75711 12.5369 10.4999 13.2796C10.5853 13.3652 16.1204 18.9003 16.2059 18.9851Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8433 23.7699H2.15677C0.965622 23.7699 0 24.7355 0 25.9267V31.124C0 32.3151 0.965622 33.2807 2.15677 33.2807H32.8432C34.0344 33.2807 35 32.3151 35 31.124V25.9267C35.0001 24.7355 34.0345 23.7699 32.8433 23.7699Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b09efbef785b0b7eaaf16b5a843f8ddc.svg";
export { ForwardRef as ReactComponent };